import axios from "axios";
const jsonConfig = require("../../Config.json");

const updateConfigurationResponse = async (payload) => {
  let allResponse = {}
  try {
    const response = await axios.put(
        jsonConfig.apiUrl + "GlobalConfiguration/" + payload.code,
        payload.data,
          {
            headers: {
              "x-functions-key": jsonConfig.key,
            },
          }
        );
      
      allResponse = response;
      return Promise.resolve(allResponse)
  }
  catch (error) {
    console.log("Error Invite Candidate", error);
      return Promise.reject(error)
  }
}

export default updateConfigurationResponse;